/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Document Service API
 * API for managing documents, templates, and file storage with AWS S3 integration
 * OpenAPI spec version: 1.2.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Document,
  DocumentGenerate,
  DocumentType,
  DocumentTypeCreate,
  DocumentUpload,
  GetAllDocumentsParams,
  GetAllTemplatesParams,
  OwnerType,
  OwnerTypeCreate,
  Template,
  TemplateUpload,
  Version
} from './schemas/documentServiceSchemas';

import { customAxiosInstanceMutator } from './custom-axios-instance';
/**
 * @summary API version
 */
export const getVersion = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Version>(
      {url: `/document/api/v1/version`, method: 'GET', signal
    },
      );
    }
  



export const getGetVersionQueryKey = () => {
    return [
    `/document/api/v1/version`
    ] as const;
    }

    
export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = unknown


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary API version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Upload a new document
 */
export const uploadDocument = (
    documentUpload: DocumentUpload,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`name`, documentUpload.name)
formData.append(`documentTypeName`, documentUpload.documentTypeName)
formData.append(`ownerTypeName`, documentUpload.ownerTypeName)
formData.append(`ownerId`, documentUpload.ownerId)
if(documentUpload.description !== undefined) {
 formData.append(`description`, documentUpload.description)
 }
formData.append(`file`, documentUpload.file)
if(documentUpload.uploadedBy !== undefined) {
 formData.append(`uploadedBy`, documentUpload.uploadedBy)
 }
if(documentUpload.subjectKey !== undefined) {
 formData.append(`subjectKey`, documentUpload.subjectKey)
 }
if(documentUpload.subjectName !== undefined) {
 formData.append(`subjectName`, documentUpload.subjectName)
 }
if(documentUpload.period !== undefined) {
 formData.append(`period`, documentUpload.period)
 }
if(documentUpload.documentDate !== undefined) {
 formData.append(`documentDate`, documentUpload.documentDate)
 }
if(documentUpload.expiryDate !== undefined) {
 formData.append(`expiryDate`, documentUpload.expiryDate)
 }

      return customAxiosInstanceMutator<Document>(
      {url: `/document/api/v1/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: DocumentUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: DocumentUpload}, TContext> => {

const mutationKey = ['uploadDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, {data: DocumentUpload}> = (props) => {
          const {data} = props ?? {};

          return  uploadDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = DocumentUpload
    export type UploadDocumentMutationError = unknown

    /**
 * @summary Upload a new document
 */
export const useUploadDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,{data: DocumentUpload}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        {data: DocumentUpload},
        TContext
      > => {

      const mutationOptions = getUploadDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all documents
 */
export const getAllDocuments = (
    params?: GetAllDocumentsParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Document[]>(
      {url: `/document/api/v1/fetch-all`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAllDocumentsQueryKey = (params?: GetAllDocumentsParams,) => {
    return [
    `/document/api/v1/fetch-all`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDocuments>>> = ({ signal }) => getAllDocuments(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDocuments>>>
export type GetAllDocumentsQueryError = unknown


export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params: undefined |  GetAllDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all documents
 */

export function useGetAllDocuments<TData = Awaited<ReturnType<typeof getAllDocuments>>, TError = unknown>(
 params?: GetAllDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List all documents for an owner
 */
export const getAllOwnerDocuments = (
    id: string,
    ownerType: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Document[]>(
      {url: `/document/api/v1/owner/${id}/${ownerType}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAllOwnerDocumentsQueryKey = (id?: string,
    ownerType?: string,) => {
    return [
    `/document/api/v1/owner/${id}/${ownerType}`
    ] as const;
    }

    
export const getGetAllOwnerDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError = unknown>(id: string,
    ownerType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOwnerDocumentsQueryKey(id,ownerType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOwnerDocuments>>> = ({ signal }) => getAllOwnerDocuments(id,ownerType, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && ownerType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllOwnerDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOwnerDocuments>>>
export type GetAllOwnerDocumentsQueryError = unknown


export function useGetAllOwnerDocuments<TData = Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError = unknown>(
 id: string,
    ownerType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOwnerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllOwnerDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOwnerDocuments<TData = Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError = unknown>(
 id: string,
    ownerType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOwnerDocuments>>,
          TError,
          Awaited<ReturnType<typeof getAllOwnerDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOwnerDocuments<TData = Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError = unknown>(
 id: string,
    ownerType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all documents for an owner
 */

export function useGetAllOwnerDocuments<TData = Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError = unknown>(
 id: string,
    ownerType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllOwnerDocumentsQueryOptions(id,ownerType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get a document by ID
 */
export const getDocumentById = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Document>(
      {url: `/document/api/v1/fetch/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentByIdQueryKey = (id?: number,) => {
    return [
    `/document/api/v1/fetch/${id}`
    ] as const;
    }

    
export const getGetDocumentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentById>>> = ({ signal }) => getDocumentById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentById>>>
export type GetDocumentByIdQueryError = unknown


export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a document by ID
 */

export function useGetDocumentById<TData = Awaited<ReturnType<typeof getDocumentById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Mark a document as deleted
 */
export const deleteDocumentApiV1RemoveId = (
    id: number,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/document/api/v1/remove/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentApiV1RemoveIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDocumentApiV1RemoveId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentApiV1RemoveId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentApiV1RemoveIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>>
    
    export type DeleteDocumentApiV1RemoveIdMutationError = unknown

    /**
 * @summary Mark a document as deleted
 */
export const useDeleteDocumentApiV1RemoveId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentApiV1RemoveId>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentApiV1RemoveIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Archive a document
 */
export const archiveDocument = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Document>(
      {url: `/document/api/v1/${id}/archive`, method: 'POST', signal
    },
      );
    }
  


export const getArchiveDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveDocument(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveDocument>>>
    
    export type ArchiveDocumentMutationError = unknown

    /**
 * @summary Archive a document
 */
export const useArchiveDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDocument>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveDocument>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getArchiveDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Download a document
 */
export const downloadDocument = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Blob>(
      {url: `/document/api/v1/download/${id}`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getDownloadDocumentQueryKey = (id?: string,) => {
    return [
    `/document/api/v1/download/${id}`
    ] as const;
    }

    
export const getDownloadDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadDocument>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDocumentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDocument>>> = ({ signal }) => downloadDocument(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDocument>>>
export type DownloadDocumentQueryError = unknown


export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a document
 */

export function useDownloadDocument<TData = Awaited<ReturnType<typeof downloadDocument>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDocument>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDocumentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new template
 */
export const uploadTemplate = (
    templateUpload: TemplateUpload,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`name`, templateUpload.name)
if(templateUpload.description !== undefined) {
 formData.append(`description`, templateUpload.description)
 }
formData.append(`file`, templateUpload.file)

      return customAxiosInstanceMutator<Template>(
      {url: `/document/api/v1/templates`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadTemplate>>, TError,{data: TemplateUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadTemplate>>, TError,{data: TemplateUpload}, TContext> => {

const mutationKey = ['uploadTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadTemplate>>, {data: TemplateUpload}> = (props) => {
          const {data} = props ?? {};

          return  uploadTemplate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof uploadTemplate>>>
    export type UploadTemplateMutationBody = TemplateUpload
    export type UploadTemplateMutationError = unknown

    /**
 * @summary Create a new template
 */
export const useUploadTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadTemplate>>, TError,{data: TemplateUpload}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadTemplate>>,
        TError,
        {data: TemplateUpload},
        TContext
      > => {

      const mutationOptions = getUploadTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all templates
 */
export const getAllTemplates = (
    params?: GetAllTemplatesParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Template[]>(
      {url: `/document/api/v1/templates`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAllTemplatesQueryKey = (params?: GetAllTemplatesParams,) => {
    return [
    `/document/api/v1/templates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getAllTemplates>>, TError = unknown>(params?: GetAllTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTemplatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTemplates>>> = ({ signal }) => getAllTemplates(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTemplates>>>
export type GetAllTemplatesQueryError = unknown


export function useGetAllTemplates<TData = Awaited<ReturnType<typeof getAllTemplates>>, TError = unknown>(
 params: undefined |  GetAllTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTemplates<TData = Awaited<ReturnType<typeof getAllTemplates>>, TError = unknown>(
 params?: GetAllTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllTemplates<TData = Awaited<ReturnType<typeof getAllTemplates>>, TError = unknown>(
 params?: GetAllTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all templates
 */

export function useGetAllTemplates<TData = Awaited<ReturnType<typeof getAllTemplates>>, TError = unknown>(
 params?: GetAllTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get a template by ID
 */
export const getTemplateById = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Template>(
      {url: `/document/api/v1/templates/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetTemplateByIdQueryKey = (id?: number,) => {
    return [
    `/document/api/v1/templates/${id}`
    ] as const;
    }

    
export const getGetTemplateByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateById>>> = ({ signal }) => getTemplateById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateById>>>
export type GetTemplateByIdQueryError = unknown


export function useGetTemplateById<TData = Awaited<ReturnType<typeof getTemplateById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateById>>,
          TError,
          Awaited<ReturnType<typeof getTemplateById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateById<TData = Awaited<ReturnType<typeof getTemplateById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateById>>,
          TError,
          Awaited<ReturnType<typeof getTemplateById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateById<TData = Awaited<ReturnType<typeof getTemplateById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a template by ID
 */

export function useGetTemplateById<TData = Awaited<ReturnType<typeof getTemplateById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Delete a template
 */
export const deleteDocumentApiV1TemplatesId = (
    id: number,
 ) => {
      
      
      return customAxiosInstanceMutator<void>(
      {url: `/document/api/v1/templates/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentApiV1TemplatesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDocumentApiV1TemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentApiV1TemplatesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentApiV1TemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>>
    
    export type DeleteDocumentApiV1TemplatesIdMutationError = unknown

    /**
 * @summary Delete a template
 */
export const useDeleteDocumentApiV1TemplatesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentApiV1TemplatesId>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentApiV1TemplatesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Generate a document from a template
 */
export const generateDocument = (
    documentGenerate: DocumentGenerate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<Document>(
      {url: `/document/api/v1/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentGenerate, signal
    },
      );
    }
  


export const getGenerateDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: DocumentGenerate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: DocumentGenerate}, TContext> => {

const mutationKey = ['generateDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateDocument>>, {data: DocumentGenerate}> = (props) => {
          const {data} = props ?? {};

          return  generateDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof generateDocument>>>
    export type GenerateDocumentMutationBody = DocumentGenerate
    export type GenerateDocumentMutationError = unknown

    /**
 * @summary Generate a document from a template
 */
export const useGenerateDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateDocument>>, TError,{data: DocumentGenerate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateDocument>>,
        TError,
        {data: DocumentGenerate},
        TContext
      > => {

      const mutationOptions = getGenerateDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Create a new document type
 */
export const saveDocumentType = (
    documentTypeCreate: DocumentTypeCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentType>(
      {url: `/document/api/v1/document-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentTypeCreate, signal
    },
      );
    }
  


export const getSaveDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDocumentType>>, TError,{data: DocumentTypeCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveDocumentType>>, TError,{data: DocumentTypeCreate}, TContext> => {

const mutationKey = ['saveDocumentType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveDocumentType>>, {data: DocumentTypeCreate}> = (props) => {
          const {data} = props ?? {};

          return  saveDocumentType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof saveDocumentType>>>
    export type SaveDocumentTypeMutationBody = DocumentTypeCreate
    export type SaveDocumentTypeMutationError = unknown

    /**
 * @summary Create a new document type
 */
export const useSaveDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDocumentType>>, TError,{data: DocumentTypeCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveDocumentType>>,
        TError,
        {data: DocumentTypeCreate},
        TContext
      > => {

      const mutationOptions = getSaveDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all document types
 */
export const getAllDocumentTypes = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentType[]>(
      {url: `/document/api/v1/document-types`, method: 'GET', signal
    },
      );
    }
  



export const getGetAllDocumentTypesQueryKey = () => {
    return [
    `/document/api/v1/document-types`
    ] as const;
    }

    
export const getGetAllDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDocumentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDocumentTypes>>> = ({ signal }) => getAllDocumentTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDocumentTypes>>>
export type GetAllDocumentTypesQueryError = unknown


export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllDocumentTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllDocumentTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all document types
 */

export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllDocumentTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get a document type by ID
 */
export const getDocumentTypeById = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<DocumentType>(
      {url: `/document/api/v1/document-types/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDocumentTypeByIdQueryKey = (id?: number,) => {
    return [
    `/document/api/v1/document-types/${id}`
    ] as const;
    }

    
export const getGetDocumentTypeByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentTypeById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypeByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentTypeById>>> = ({ signal }) => getDocumentTypeById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentTypeByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentTypeById>>>
export type GetDocumentTypeByIdQueryError = unknown


export function useGetDocumentTypeById<TData = Awaited<ReturnType<typeof getDocumentTypeById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypeById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypeById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentTypeById<TData = Awaited<ReturnType<typeof getDocumentTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypeById>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypeById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentTypeById<TData = Awaited<ReturnType<typeof getDocumentTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a document type by ID
 */

export function useGetDocumentTypeById<TData = Awaited<ReturnType<typeof getDocumentTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentTypeByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a new owner type
 */
export const saveOwnerType = (
    ownerTypeCreate: OwnerTypeCreate,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OwnerType>(
      {url: `/document/api/v1/owner-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ownerTypeCreate, signal
    },
      );
    }
  


export const getSaveOwnerTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOwnerType>>, TError,{data: OwnerTypeCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveOwnerType>>, TError,{data: OwnerTypeCreate}, TContext> => {

const mutationKey = ['saveOwnerType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveOwnerType>>, {data: OwnerTypeCreate}> = (props) => {
          const {data} = props ?? {};

          return  saveOwnerType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveOwnerTypeMutationResult = NonNullable<Awaited<ReturnType<typeof saveOwnerType>>>
    export type SaveOwnerTypeMutationBody = OwnerTypeCreate
    export type SaveOwnerTypeMutationError = unknown

    /**
 * @summary Create a new owner type
 */
export const useSaveOwnerType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveOwnerType>>, TError,{data: OwnerTypeCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveOwnerType>>,
        TError,
        {data: OwnerTypeCreate},
        TContext
      > => {

      const mutationOptions = getSaveOwnerTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all owner types
 */
export const getAllOwnerTypes = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OwnerType[]>(
      {url: `/document/api/v1/owner-types`, method: 'GET', signal
    },
      );
    }
  



export const getGetAllOwnerTypesQueryKey = () => {
    return [
    `/document/api/v1/owner-types`
    ] as const;
    }

    
export const getGetAllOwnerTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllOwnerTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOwnerTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOwnerTypes>>> = ({ signal }) => getAllOwnerTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllOwnerTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOwnerTypes>>>
export type GetAllOwnerTypesQueryError = unknown


export function useGetAllOwnerTypes<TData = Awaited<ReturnType<typeof getAllOwnerTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOwnerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllOwnerTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOwnerTypes<TData = Awaited<ReturnType<typeof getAllOwnerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOwnerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllOwnerTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllOwnerTypes<TData = Awaited<ReturnType<typeof getAllOwnerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all owner types
 */

export function useGetAllOwnerTypes<TData = Awaited<ReturnType<typeof getAllOwnerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOwnerTypes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllOwnerTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get an owner type by ID
 */
export const getOwnerTypeById = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceMutator<OwnerType>(
      {url: `/document/api/v1/owner-types/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetOwnerTypeByIdQueryKey = (id?: number,) => {
    return [
    `/document/api/v1/owner-types/${id}`
    ] as const;
    }

    
export const getGetOwnerTypeByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOwnerTypeById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerTypeByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnerTypeById>>> = ({ signal }) => getOwnerTypeById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerTypeByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnerTypeById>>>
export type GetOwnerTypeByIdQueryError = unknown


export function useGetOwnerTypeById<TData = Awaited<ReturnType<typeof getOwnerTypeById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerTypeById>>,
          TError,
          Awaited<ReturnType<typeof getOwnerTypeById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerTypeById<TData = Awaited<ReturnType<typeof getOwnerTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnerTypeById>>,
          TError,
          Awaited<ReturnType<typeof getOwnerTypeById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnerTypeById<TData = Awaited<ReturnType<typeof getOwnerTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an owner type by ID
 */

export function useGetOwnerTypeById<TData = Awaited<ReturnType<typeof getOwnerTypeById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnerTypeById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerTypeByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
